import React, { FC, ReactElement } from "react";
import { Button } from "@material-ui/core";

import { useProfileUpdatedModalStyles } from "./ProfileUpdatedModalStyles";
import ProfileModal from "../ProfileModal/ProfileModal";
import { BtnLabelProps } from "../../../../../types/user";

interface ProfileUpdatedModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: () => Promise<void>;
    btnLabel: BtnLabelProps;
}

const ProfileUpdatedModal: FC<ProfileUpdatedModalProps> = ({ isOpen, onClose, onSubmit, btnLabel }): ReactElement => {
    const classes = useProfileUpdatedModalStyles();

    return (
        <ProfileModal
            isOpen={isOpen}
            onClose={onClose}
            title={"Your profile is updated"}
            isComponentSelected
            isProfileUpdated
            hideBackdrop
        >
            <div className={classes.buttonWrapper}>
                <Button
                    className={classes.button}
                    onClick={onSubmit}
                    variant="contained"
                    color="primary"
                    size="medium"
                    disabled={btnLabel?.isDisabled}
                >
                    {btnLabel.label}
                </Button>
            </div>
        </ProfileModal>
    );
};

export default ProfileUpdatedModal;
